var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "absolute transition-all duration-300",
      style: {
        top: _vm.availability.position.top,
        left: _vm.availability.position.left
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "border border-l-4 rounded-lg bg-pure-white px-3 flex flex-col cursor-pointer shadow-md overflow-y-hidden transition-all duration-300",
          class: [
            _vm.isHasTwoSpaces ? "py-2 gap-1" : "py-0 gap-0 justify-center"
          ],
          style: {
            height: _vm.availability.element.height,
            width: _vm.availability.element.width,
            borderColor: _vm.availability.element.borderColor
          },
          on: {
            click: function($event) {
              _vm.editOpened = true
            }
          }
        },
        [
          _vm.availability.is_overlapped && _vm.isHasThreeSpaces
            ? _c(
                "div",
                [
                  _c("BlIcon", {
                    staticClass: "h-6 w-6",
                    attrs: { icon: "warning", color: "tomato-7" }
                  })
                ],
                1
              )
            : _vm.isHasTwoSpaces
            ? _c(
                "div",
                {
                  staticClass:
                    "h-7 w-7 flex-shrink-0 rounded-full grid place-items-center",
                  style: { background: _vm.availability.secondary_color }
                },
                [
                  _vm.isOpenRoom
                    ? _c("BlIcon", {
                        staticClass: "h-4 w-4",
                        attrs: { icon: "door" }
                      })
                    : _vm.slotType === "therapist"
                    ? _c("BlIcon", {
                        staticClass: "h-4 w-4",
                        attrs: { icon: "door" }
                      })
                    : _vm.slotType === "room"
                    ? _c("BlIcon", {
                        staticClass: "h-4 w-4",
                        attrs: { icon: "user" }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex",
              attrs: { title: _vm.availability.title.name }
            },
            [
              _c("BlTextBody2", {
                staticClass: "text-slate-800 line-clamp-2",
                attrs: { text: _vm.availability.title.name }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.enableBranch &&
          _vm.slotType === "therapist" &&
          _vm.availability.room.branch &&
          _vm.isHasTwoSpaces
            ? _c("div", { staticClass: "flex" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "h-7 max-w-36 px-2 flex items-center justify-center rounded",
                    style: {
                      backgroundColor:
                        _vm.availability.room.branch.background_color || "unset"
                    },
                    attrs: { title: _vm.availability.room.branch.name }
                  },
                  [
                    _c("BlTextBody2", {
                      staticClass: "truncate",
                      style: {
                        color: _vm.availability.room.branch.color || "unset"
                      },
                      attrs: { text: _vm.availability.room.branch.name || "-" }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.availability.is_overlapped
            ? _c(
                "div",
                [
                  _vm.isHasThreeSpaces
                    ? _c("BlTextSubtitle3", {
                        staticClass: "text-tomato-700",
                        attrs: {
                          text:
                            "Overlapping availabilities detected in this slot."
                        }
                      })
                    : _c("BlTextSubtitle3", {
                        staticClass: "text-tomato-700",
                        attrs: { text: "Overlapping slot." }
                      })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.editOpened
        ? _c("EditAvailabilitiesModal", {
            attrs: {
              availabilityId: _vm.availability.id,
              availabilityDate: _vm.availability.date
            },
            on: {
              "close-modal": function($event) {
                _vm.editOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eeff8dc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeff8dc8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/timeslot/Slot.vue
// module id = null
// module chunks = 